module.exports = __webpack_public_path__ + "img/word.c1e19c8a.png";